import {types} from './types';

const initialState = {
    view: {

    }
}

export function statisticsReducer(state = initialState, action) {
    switch (action.type) {
        case types.SET_GET_STATISTICS:
            return { ...state, view: action.payload};
        default:
            return state
    }
}